import React from 'react'
import { observer } from 'mobx-react'

const InheritedChartSlot = ({ store, position }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)

    if (!question) return null

    const data = store.getChartDataForQuestion(
        `${question.questionId}-inherited`,
        position,
    )

    return (
        <div className="pp-chart-slot-container">
            <div className="pp-derived-slot">
                {question
                    ? store.getChart(
                        {
                            ...data,
                            title: '',
                            containerSize: { height: 400, width: 450 },
                            chartType: 'standardColumn',
                            surveyId: question.surveyId,
                            settings: question.settings,
                            kpiType: 'inherited',
                        },
                        data.data,
                    )
                    : null}
            </div>
        </div>
    )
}

export default observer(InheritedChartSlot)
